module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    staticClass: "box-set",
    attrs: {
      "model": _vm.form,
      "label-width": "120px"
    }
  }, [_c('el-card', {
    attrs: {
      "header": "设置规则内容",
      "shadow": "naver"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "名称",
      "prop": "package_name",
      "rules": {
        required: true,
        message: '名称',
        trigger: 'blur'
      }
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 30,
      "placeholder": "最多30个字"
    },
    model: {
      value: (_vm.form.package_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "package_name", $$v)
      },
      expression: "form.package_name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "分类",
      "rules": {
        required: true,
        message: '名称',
        trigger: 'blur'
      }
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.form.brand_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "brand_id", $$v)
      },
      expression: "form.brand_id"
    }
  }, _vm._l((_vm.brandList), function(item) {
    return _c('el-option', {
      key: item.attribute_id,
      attrs: {
        "label": item.attribute_name,
        "value": item.attribute_id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 20
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用法用量",
      "rules": {
        required: true,
        message: '用法用量',
        trigger: 'blur'
      }
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 160,
      "placeholder": ""
    },
    model: {
      value: (_vm.form.dosage),
      callback: function($$v) {
        _vm.$set(_vm.form, "dosage", $$v)
      },
      expression: "form.dosage"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 20
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "功能主治",
      "rules": {
        required: true,
        message: '功能主治',
        trigger: 'blur'
      }
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 160,
      "placeholder": ""
    },
    model: {
      value: (_vm.form.purpose),
      callback: function($$v) {
        _vm.$set(_vm.form, "purpose", $$v)
      },
      expression: "form.purpose"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-card', {
    attrs: {
      "header": "主商品"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "选择主商品"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-button', {
    staticClass: "el-icon-plus",
    attrs: {
      "type": "primary",
      "size": "mini",
      "round": ""
    },
    on: {
      "click": _vm.relMainClick
    }
  }, [_vm._v("主商品选择\n            ")]), _vm._v(" "), _c('GoodsSelect', {
    attrs: {
      "items-visible": _vm.mainVisible,
      "get-status": _vm.setMainStatus,
      "single": _vm.singleData,
      "rel-items-ids": _vm.relMain,
      "item-type": _vm.form.item_type
    },
    on: {
      "chooseStore": _vm.chooseMainAction,
      "closeStoreDialog": _vm.closeMainDialogAction
    }
  })], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "line-height": "normal"
    },
    attrs: {
      "data": _vm.relMain
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "ID",
      "prop": "item_id",
      "width": "90"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "名称",
      "prop": "item_name",
      "min-width": "90"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "价格(元/g)",
      "prop": "price",
      "width": "90"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "规格(克/g)",
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "width": "90",
            "size": "mini"
          },
          model: {
            value: (scope.row.spec),
            callback: function($$v) {
              _vm.$set(scope.row, "spec", $$v)
            },
            expression: "scope.row.spec"
          }
        })]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('el-card', {
    attrs: {
      "header": "次商品",
      "shadow": "naver"
    }
  }, [_c('SkuSelector', {
    attrs: {
      "data": _vm.relItems,
      "limit": 1,
      "hiddenData": _vm.relMain
    },
    on: {
      "change": _vm.getItems,
      "newPrice": _vm.getNewPrice
    }
  })], 1), _vm._v(" "), _c('el-card', {
    attrs: {
      "header": "商品详情图"
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "*商品图"
    }
  }, [_c('div', [_c('div', {
    staticClass: "pics-box"
  }, [_c('ul', {
    staticClass: "goodspic-wrap"
  }, [_c('draggable', {
    staticClass: "components-view",
    attrs: {
      "options": _vm.dragIssuesOptions
    },
    model: {
      value: (_vm.form.pics),
      callback: function($$v) {
        _vm.$set(_vm.form, "pics", $$v)
      },
      expression: "form.pics"
    }
  }, _vm._l((_vm.form.pics), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "goodspic",
      on: {
        "mouseenter": function($event) {
          return _vm.picsEnter(index)
        },
        "mouseleave": _vm.picsLeave
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.wximageurl + item
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "goodspic-mask",
      class: (_vm.picsCurrent == index) ? 'on' : ''
    }, [_c('div', {
      staticClass: "iconfont icon-trash-alt",
      on: {
        "click": function($event) {
          return _vm.removePicsImg(index)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "iconfont icon-arrows-alt"
    })])])
  }), 0)], 1), _vm._v(" "), (_vm.form.pics.length < 9) ? _c('div', {
    staticClass: "upload-box",
    on: {
      "click": _vm.handlePicsChange
    }
  }, [_c('i', {
    staticClass: "iconfont icon-camera"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_c('p', [_vm._v("1. 最多可上传9个图片，文件格式为bmp、png、jpeg、jpg或gif，大小不超过2M（建议尺寸：500px * 500px）")]), _vm._v(" "), _c('p', [_vm._v("2. 拖动图片进行可排序")])])]), _vm._v(" "), _c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.picsDialog,
      "sc-status": _vm.isGetPics,
      "is-most": _vm.multiple
    },
    on: {
      "chooseImg": _vm.pickPics,
      "closeImgDialog": _vm.closePicsDialog
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loader),
      expression: "loader"
    }],
    attrs: {
      "header": "图文详情",
      "shadow": "never"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "模式"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.mode),
      callback: function($$v) {
        _vm.mode = $$v
      },
      expression: "mode"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 'richText'
    }
  }, [_vm._v("富文本")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 'component'
    }
  }, [_vm._v("组件式")])], 1)], 1), _vm._v(" "), (_vm.mode === 'richText') ? [_c('vue-html5-editor', {
    ref: "editor",
    attrs: {
      "content": _vm.form.intro,
      "height": 360
    },
    on: {
      "change": _vm.updateContent
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "tpl_item img",
    on: {
      "click": _vm.addImgPreview
    }
  }, [_c('i', {
    staticClass: "iconfont icon-image"
  }), _vm._v("图片\n            ")])] : [_c('richTextEditor', {
    attrs: {
      "data": _vm.content,
      "control": ['film', 'slider', 'heading', 'writing']
    },
    on: {
      "change": _vm.handleContent
    }
  })], _vm._v(" "), _c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.thumbDialog,
      "sc-status": _vm.isGetThumb,
      "isMost": true
    },
    on: {
      "chooseImg": _vm.pickThumb,
      "closeImgDialog": _vm.closeThumbDialog
    }
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "content-center"
  }, [(_vm.hasSaveButton) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitActivityAction()
      }
    }
  }, [_vm._v("保存")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.handleCancel.apply(null, arguments)
      }
    }
  }, [_vm._v("返回")])], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-27c94b57", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27c94b57"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/mall/goods/package/add.vue
// module id = 2556
// module chunks = 0